import React from "react";
import i18n from "i18next";
import PropTypes from "prop-types";

class EmptyResult extends React.Component {
  render() {
    const { text, className } = this.props;
    return (
      <div className={`empty-container ${className || ""}`}>
        <img
          className="empty-image"
          src={require("@/assets/images/empty-result.svg")}
          alt=""
        />
        <div
          className="empty-result"
          dangerouslySetInnerHTML={{
            __html: text || i18n.t("TCMS01015_searchResult"),
          }}
        />
      </div>
    );
  }
}

EmptyResult.propTypes = {
  text: PropTypes.string,
};

EmptyResult.defaultProps = {
  text: "",
};

export default EmptyResult;
